import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/CheckoutReport/SearchReport",
    method: "get",
    params
  });
}
export function getColumns(params) {
  return request({
    url: "/CheckoutReport/GetReportHeader",
    method: "get",
    params
  });
}
